export default [
  {
    position: "absolute",
    top: 10,
    left: 22,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "workforceInsightP3.mTitleOne",
    mBody: "workforceInsightP3.mBodyOne",
    isVideo: true,
    videoThumb: "HR-Dash-2-Thumb",
    videoURL: "HR-Dashboard-2.mp4",
    vidIcon: true,
    id: "HR_WorkforceInsightDashboard_Video_Subscribe",
    index: 0
  },
  {
    position: "absolute",
    top: 18,
    left: 46,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "workforceInsightP3.mTitleTwo",
    mBody: "workforceInsightP3.mBodyTwo",
    isVideo: true,
    videoThumb: "HR-Dash-1-Thumb",
    videoURL: "HR-Dashboard-1.mp4",
    vidIcon: true,
    id: "HR_WorkforceInsightDashboard_Video_ChartsandReports",
    index: 1
  },
  {
    position: "absolute",
    top: 2,
    left: 12,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "workforceInsightP3.ttTextOne",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_WorkforceInsightDashboard_Navigation_Home",
    index: 2
  },
  {
    position: "absolute",
    top: 2,
    left: 27.7,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "workforceInsightP3.ttTextTwo",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_WorkforceInsightDashboard_Navigation_TeamMembers",
    index: 3
  },
  {
    position: "absolute",
    top: 2,
    left: 33.9,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "workforceInsightP3.ttTextFour",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_WorkforceInsightDashboard_Navigation_Dashboards",
    index: 4
  },
  {
    position: "absolute",
    top: 2,
    left: 38.9,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "workforceInsightP3.ttTextThree",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_WorkforceInsightDashboard_Navigation_Reports",
    index: 5
  },
];
